import ApiService from "./ApiService"

class UserApiService extends ApiService {
	static async getUser() {
		const response = await fetch(`${super.getBaseUrl()}/user`, {
			headers: {
				"X-Access-Token": super.getAccessToken(),
				"Content-Type": "application/json"
			}
		})
		return await response.json()
	}
}

export default UserApiService



// WEBPACK FOOTER //
// ./src/api/UserApiService.js